export default "__VITE_ASSET__CEbNYYYG__"